import { gsap, Power2 } from 'gsap'
import Lottie from 'lottie-web'
import {startHeroSliderAnimation} from "./sections/hero-sequence";


if ($('body').hasClass('front-page') || $('body').hasClass('news-page-template') || $('body').hasClass('single-news-page')) {
  let preloaderLottie = $('#preloader-animation')

  let pageLoaded = false
  let loaderInterval = null
  let maxInterval = 10000
  let currentInterval = 0

  loaderInterval = setInterval(function () {
    currentInterval += 100
    if (pageLoaded && $('body').hasClass('page-loaded') || currentInterval > maxInterval) {
      clearInterval(loaderInterval)
      removePreloader()
    }
  }, 100)

  function removePreloader () {
    $('body').removeClass('is-loading')
    gsap.fromTo('#preloader',
      { y: 0 },
      {
        y: '-100vh',
        duration: 1,
        onComplete: pageActive,
        ease: Power2.easeIn
      }
    )

    startHeroSliderAnimation()
  }

  function pageActive () {
    $('body').removeClass('page-loading')
    $('#preloader').remove()
    $('body').removeClass('is-loading')

  }

  if (preloaderLottie.length) {

    let path = preloaderLottie.attr('data-animation-path')
    let introId = 'preloader-animation'

    let svgContainer = document.getElementById(introId)

    let animation = Lottie.loadAnimation({
      container: svgContainer,
      animType: 'svg',
      loop: false,
      autoplay: true,
      path: path
    });

    animation.addEventListener('complete', animationDone);

    function animationDone () {
      $('body').addClass('page-loaded')
      $('body').removeClass('is-loading')
    }
  } else {

    $('body').addClass('page-loaded')
    $('body').removeClass('is-loading')

  }

  $(window).on('load', function (e) {
    pageLoaded = true
  })

}
